<script>
    /*
    	LandingPageHeader.svelte
    */

    import { onMount } from 'svelte';
    import { AccountStore } from "../../common/account";

    // TCARE components
    import LandingPageTextButton from './LandingPageTextButton.svelte';


    export let onHomeClick;
    export let onLoginClick;
    
    onMount(() => {
        // console.log('');
        // console.log('LandingPageHeader onMount');
        // console.log('$AccountStore');
        // console.log($AccountStore);
        // console.log('');        
    })

</script>

<style>
    .landing-page-header {
        z-index: 900;
        height: 135px;
        width: 100%;
        position: fixed;
        top: 0px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: var(--tcui-primary);
    }

    .landing-page-header .block-row {
        width: 1200px;
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        /* border: 1px solid red; */
    }

    .landing-page-header .logo img {
        height: 40px;
    }
    
    .landing-page-header .buttons-row {
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }

    :global(.landing-page-header .login-button button) {
        background-color: #80488C;
    }

    :global(.landing-page-header .login-button button:hover) {
        background-color: var(--tcui-secondary);
    }


    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="landing-page-header">
    <div class="block-row">
        <div class="logo">
            <img src='/img/logo_wide_reverse.png' alt='colored shape' draggable="false">        
        </div>
        <div class="buttons-row">
            {#if $AccountStore.isLoggedIn}
                {#if $AccountStore.roles.length > 0}
                    <LandingPageTextButton onClick={onHomeClick} label={'Home'} />
                {/if}
                <div class="login-button">
                    <LandingPageTextButton onClick={onLoginClick} label={'Logout'} />
                </div>
            {/if}
        </div>
    </div>
</div>


